import axiosInstance from "./axiosInstance";

export const decodeJWT = (jwtToken: any) => {
	return axiosInstance.post("/auth/decode", {
		data: jwtToken
	}).then((result) => {
		return result.data.data; //returns filters array
	});
};
